<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.editUser") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: var(--main_theme_clr)">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="12"
            identifier="userImage"
            :preSelectedImage="data.image.path"
            :placeholder="$t('PLACEHOLDERS.userImage')"
            @selectImage="selectImage"
            
          />
          <!-- End:: Image Upload Input -->

          <!-- Start:: first_name Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.user_name')"
            v-model.trim="data.user_name"
            required
            class=""
          />
          <!-- End:: first_name Input -->

          <!-- Start:: last_name Input -->
          <base-phone-input
            col="4"
            required
            v-model="data.phone"
            @dialCode="dialCode"
            @isoCode="isoCode"
            :placeholder="$t('PLACEHOLDERS.phone')"
            :defaultCountry="data.iso_code"
            :key="key"
          />
          <!-- End:: last_name Input -->

          <!-- Start:: Phone Input -->
          <base-input
            col="4"
            type="email"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            required
          />
          <!-- End:: Phone Input -->

          <!-- Start:: Second Phone Input -->

          <base-image-upload-input
            col="6"
            identifier="id_image"
            :preSelectedImage="data.id_image.path"
            :placeholder="$t('PLACEHOLDERS.id_image')"
            @selectImage="selectImage1"
            
          />
          <base-image-upload-input
            col="6"
            identifier="licens_image"
            :preSelectedImage="data.licens_image.path"
            :placeholder="$t('PLACEHOLDERS.licens_image')"
            @selectImage="selectImage2"
            
          />

          <!-- Start:: gender Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.bank_name')"
            v-model.trim="data.bank_name"
          />
          <!-- End:: gender Input -->

          <!-- Start:: Joining Date Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.bank_number')"
            v-model.trim="data.bank_number"
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.iban')"
            v-model.trim="data.iban"
          />
          <!-- {{ data.role }} -->
          <!-- End:: Roles Input -->

          <!-- Start:: Deactivate Switch Input -->
          <!-- <div class="input_wrapper switch_wrapper my-5">
            <v-switch color="green" :label="data.active ? $t('PLACEHOLDERS.active') : $t('PLACEHOLDERS.notActive')"
              v-model="data.active" hide-details></v-switch>
          </div> -->
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Activate Edit Password Switch Input -->
          <!-- <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="$t('PLACEHOLDERS.editPassword')"
              v-model="data.enableEditPassword"
              hide-details
            ></v-switch>
          </div> -->
          <!-- End:: Activate Edit Password Switch Input -->

          <Transition name="fadeInUp" mode="out-in">
            <div class="col-12" v-if="data.enableEditPassword">
              <div class="row">
                <!-- Start:: Password Input -->
                <base-input
                  col="6"
                  type="password"
                  :placeholder="$t('PLACEHOLDERS.password')"
                  v-model.trim="data.password"
                  required
                />
                <!-- End:: Password Input -->

                <!-- Start:: Confirm Password Input -->
                <base-input
                  col="6"
                  type="password"
                  :placeholder="$t('PLACEHOLDERS.confirmPassword')"
                  v-model.trim="data.passwordConfirmation"
                  required
                />
                <!-- End:: Confirm Password Input -->
              </div>
            </div>
          </Transition>

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BasePhoneInput from "@/components/formInputs/BasePhoneInput.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "EditAdmin",
  components: {
    BasePhoneInput,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        id_image: {
          path: null,
          file: null,
        },
        licens_image: {
          path: null,
          file: null,
        },
        user_name: null,
        phone: null,
        dial_code: null,
        iso_code: null,
        email: null,
        bank_name: null,
        bank_number: null,
        iban: null,
        numberOfVisits: null,
        lastVisit: null,
      },
      allAreas: [],
      roles: [],
      // End:: Data Collection To Send
    };
  },

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      allRoles: "ApiGetsModule/allRoles",
    }),
    // End:: Vuex Getters
  },

  methods: {
    dialCode(dialCode) {
      this.data.dial_code = dialCode;
    },
    isoCode(iosCode) {
      this.data.iso_code = iosCode;
    },
    async getAllareas() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "areas?page=0&limit=0&is_active=1",
        });
        // console.log("All Data ==>", res.data.data);
        this.allAreas = res.data.data;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    async getRoles() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "roles?page=0&limit=0&status=1",
        });
        this.roles = res.data.data.data;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // Start:: Get Data To Show
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `clients/${this.id}`,
        });

        const client = res.data.data.Client;

        this.data.image.path = client.avatar;
        this.data.user_name = client.name;
        this.data.phone = client.mobile;
        this.data.dial_code = client.dial_code;
        this.data.iso_code = client.code;
        this.data.email = client.email;
        this.data.id_image.path = client.identity_image;
        this.data.licens_image.path = client.license_image;
        this.data.bank_name = client.bank_name;
        this.data.bank_number = client.account_number;
        this.data.iban = client.iban;
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },
    // End:: Get Data To Show

    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    selectImage1(selectedImage) {
      this.data.id_image = selectedImage;
    },
    selectImage2(selectedImage) {
      this.data.licens_image = selectedImage;
    },
    // End:: Select Upload Image

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      if (this.data.image.file) {
        REQUEST_DATA.append("avatar", this.data.image.file);
      }
      if (this.data.id_image.file) {
        REQUEST_DATA.append("identity_image", this.data.id_image.file);
      }
      if (this.data.licens_image.file) {
        REQUEST_DATA.append("license_image", this.data.licens_image.file);
      }
      if (this.data.user_name) {
        REQUEST_DATA.append("name", this.data.user_name);
      }
      if (this.data.phone) {
        REQUEST_DATA.append("mobile", this.data.phone);
        REQUEST_DATA.append(
          "dial_code",
          this.data?.dial_code?.startsWith("+")
            ? this.data?.dial_code
            : "+" + this.data?.dial_code
        );
        REQUEST_DATA.append("code", this.data.iso_code);
      }
      if (this.data.email) {
        REQUEST_DATA.append("email", this.data.email);
      }
      if (this.data.bank_name) {
        REQUEST_DATA.append("bank_name", this.data.bank_name);
      }
      if (this.data.bank_number) {
        REQUEST_DATA.append("account_number", this.data.bank_number);
      }
      if (this.data.iban) {
        REQUEST_DATA.append("iban", this.data.iban);
      }
      REQUEST_DATA.append("_method", "PUT");
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `clients/${this.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/clients/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  async created() {
    // Start:: Fire Methods
    this.getRoles();
    this.getAllareas();
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>
